const $$splitErrorComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/dashboard.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/dashboard.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { dashboardSearch } from '@/app/lib/dashboard-search';
import { rethrowUnlessUnauthorized } from '@/app/lib/redirect-to-login';
import { getDailyDashboardQuery } from '@/features/dashboard/lib/daily-dashboard.query';
export const Route = createFileRoute('/_authenticated/dashboard')({
  validateSearch: dashboardSearch,
  loaderDeps: ({
    search
  }) => ({
    date: search.date
  }),
  loader: async ({
    context,
    deps,
    location
  }) => {
    try {
      await context.queryClient.ensureQueryData(getDailyDashboardQuery({
        controllers: {
          dashboardController: context.deps.controllers.dashboardController
        },
        date: deps.date ?? null
      }));
    } catch (error) {
      await rethrowUnlessUnauthorized(error, context.queryClient, `${location.pathname}${location.searchStr}`);
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});